import { Component } from '@angular/core';

@Component({
    selector: 'fc-error404',
    templateUrl: './error404.component.html',
    styleUrls: ['./error404.component.scss'],
    standalone: false
})
export class Error404Component {}
